module.exports = __webpack_public_path__ + "img/MPHB_sala_comedor.0b367f01.jpg";